import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { NavContentStrapiService } from '../services/nav-content-strapi.service';
import { LibConfig } from '@challenger/care/models/lib-config.model';
import { LIB_CONFIG } from '@challenger/care/lib-config';

@Component({
  selector: 'vm-header-side-nav',
  templateUrl: './header-side-nav.component.html',
  styleUrls: ['./header-side-nav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideInOut', [
      state(
        'out',
        style({
          transform: 'translate3d(-100%,0,0)',
        })
      ),
      state(
        'in',
        style({
          transform: 'translate3d(0,0,0)',
        })
      ),
      transition('out => in', animate('250ms ease-in-out')),
      transition('in => out', animate('300ms cubic-bezier(0, 0, 0.450, 1)')),
    ]),

    trigger('slideInLeft', [
      state(
        'default',
        style({
          transform: 'translate3d(0,0,0)',
        })
      ),
      state(
        'slideLeft',
        style({
          transform: 'translate3d(-100%,0,0)',
        })
      ),
      transition('default => slideLeft', animate('250ms cubic-bezier(0, 0, 0.450, 1)')),
      transition('slideLeft => default', animate('250ms cubic-bezier(0, 0, 0.450, 1)')),
    ]),

    trigger('slideInRight', [
      state(
        'default',
        style({
          transform: 'translate3d(100%,0,0)',
          visibility: 'hidden',
        })
      ),
      state(
        'slideRight',
        style({
          transform: 'translate3d(0,0,0)',
          visibility: 'visible',
        })
      ),
      transition('default => slideRight', [animate('250ms cubic-bezier(0.000, 0.000, 0.450, 1.000)')]),
      transition('slideRight => default', [animate('250ms cubic-bezier(0.000, 0.000, 0.450, 1.000)')]),
    ]),
  ],
})
export class HeaderSideNavComponent implements OnInit {
  showSideNav = false;
  section: string;
  menuState = 'default';
  subMenuState = 'default';
  navState = 'out';
  contentBaseUrl: string;
  assetsPrefix: string | undefined;
  navigationData: any[] = [];
  homeNavigation: any;

  private notifierToUnsubscribe$ = new Subject();

  constructor(private navContentService: NavContentStrapiService, @Inject(LIB_CONFIG) private config: LibConfig) {}

  ngOnInit(): void {
    this.contentBaseUrl = this.config.strapiURL;
    this.assetsPrefix = this.config.assetsPath;

    this.navContentService
      .getNavigation()
      .pipe(takeUntil(this.notifierToUnsubscribe$))
      .subscribe((data) => {
        const navigations = [...data?.data?.navigations];
        navigations
          .sort((a: any, b: any) => a?.displayOrder - b?.displayOrder)
          .forEach((navigation: any) => {
            if (navigation?.children?.length > 0) {
              this.navigationData.push(navigation);
            } else {
              if (navigation?.title === 'Home') {
                this.homeNavigation = navigation;
              }
            }
          });
      });
  }

  onClick($event: any) {}

  onSidebarClose() {
    this.showSideNav = false;
    this.navState = 'out';
    this.menuState = 'default';
    this.subMenuState = 'default';
    document.body.style.overflow = 'visible';
  }

  toggleSideNav() {
    this.showSideNav = true;
    this.navState = 'in';
    document.body.style.overflow = 'hidden';
  }

  showSubmenu(el) {
    const sectionId = el.getAttribute('data-section');
    this.section = sectionId;
    this.menuState = 'slideLeft';
    this.subMenuState = 'slideRight';
    return false;
  }
}
